import { render, staticRenderFns } from "./viewsavings.vue?vue&type=template&id=127320e0&scoped=true&"
import script from "./viewsavings.vue?vue&type=script&lang=js&"
export * from "./viewsavings.vue?vue&type=script&lang=js&"
import style0 from "./viewsavings.vue?vue&type=style&index=0&id=127320e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127320e0",
  null
  
)

export default component.exports